"use client";
import React, { useEffect, useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuGroup,
  DropdownMenuShortcut,
} from "../../ui/dropdown-menu";
import { Button } from "../../ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "../../ui/avatar";
import { useRouter } from "next/navigation";
import useAuthStore from "@/lib/useAuthStore";
import { ChevronDown } from "lucide-react";
import Link from "next/link";


const NavDropDown = ()  => {
  const {user , getUser,logOutUser}:any = useAuthStore();
  useEffect(()=>{getUser()},[])
  const {push} = useRouter()

  // Add open state
  const [open, setOpen] = useState(false);

  const logOutHandler = () => {
    if (logOutUser) {
      logOutUser();
    }
    push('/login')
  }

  // Handlers for hover and click
  const handleMouseEnter = () => setOpen(true);

  return (
    <>
      <DropdownMenu modal={false} open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger asChild onMouseEnter={() => setOpen(true)}>
          <Button
            variant="ghost"
            className="relative h-10 w-10 bg-primary rounded-full border-[2px] border-white hover:bg-primary"
            style={{outline: "none"}}

          >
            <Avatar className="h-6 w-6 text-white">
              <AvatarFallback className="bg-transparent uppercase">{user?.username && user?.username[0]}</AvatarFallback>
            </Avatar>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-56 "
          style={{zIndex:'999999999'}}
          align="end"
          forceMount
           onMouseLeave={() => setOpen(false)} 
        >
          <DropdownMenuLabel className="font-normal  ">
            <div className="flex flex-col space-y-1">
              <p className="text-sm font-medium   leading-none">{user?.username}</p>
              <p className="text-xs leading-none   text-muted-foreground">
                {user?.email}
              </p>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            { <DropdownMenuItem className="cursor-pointer">
              <Link href="/dashboard" className="block w-full">Dashboard</Link>
            </DropdownMenuItem>}
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={()=>logOutHandler()} className="cursor-pointer">
            Log Out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <span onMouseEnter={() => setOpen(true)}>
             <ChevronDown className="w-3"  onMouseLeave={() => setOpen(false)} />
      </span>
    </>
  );
};

export default NavDropDown;
